module.exports = "<p>\r\n  ffrdc works!\r\n</p>\r\n"